<template>
  <!-- 서비스요청 -> 서비스요청이력 메인 -> 작업관리 탭 -->
  <div>
    <loading
      :active.sync="isLoadingDetail"
      :can-cancel="true"
      :is-full-page="false"
    ></loading>
    <el-tabs
      type="card"
      v-model="activeName"
      @tab-click="tabClickByExeWflowDetail"
      ref="tab"
      class="el-tab"
    >
      <el-tab-pane name="wrkprogress" :label="$t('messages.lblProgressStatus')">
        <template>
          <div class="tab-table">
            <wrk-prg-flow-detail
              :flowWorkflowStatus="flowWorkflowStatus"
              :workFlowList="calFlowWorkflow"
            >
              {{ $t("messages.titTblWorkFlowInfo") }}
            </wrk-prg-flow-detail>
          </div>
          <el-divider></el-divider>
          <div class="tab-table">
            <div class="ly-detail-content">
              <wrk-prg-list :exeWflowId="exeWflowId">
                {{ $t("messages.titTblWorkFlowHistory") }}
              </wrk-prg-list>
            </div>
          </div>
        </template>
      </el-tab-pane>
                  <!-- ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////// -->
                  <el-tab-pane
                    v-for="step in fileterWrkStep"
                    :key="step.wflowStepId"
                    :name="'' + step.wflowStepCd"
                    :label="step.wflowStepKoNm"
                  >
                    <!--
                      단계티켓
                      -. 단계완료 설정이 수동인 경우
                      -. 작업분류코드는 0
                    -->
                    <!--
                    <wrk-step-comm-btn
                      :style="'height:35px'"
                      v-if="activeName != 'wrkprogress'"
                      :exeWflowId="exeWflowInfo.exeWflowId"
                      :stepCd="activeName"
                      :stepAutGroupId="stepAutGroupId"
                      :stepAutrId="stepAutrId"
                      :ticketInfo="filterCurrentStepTicket"
                      :activeButtonList="activeStepBtnList"
                      :allTicketList="allExeWflowTicketList"
                    ></wrk-step-comm-btn>-->
                    <template v-for="process in viewWorkflowProcessList">
                      <!-- 탭으로 표시될 공정 -->
                      <template
                        v-if="
                          step.wflowStepCd == process.stepCd &&
                          process.isCreateTab &&
                          process.isChild
                        "
                      >
                        <div :key="process.wflowPrcssId">
                          <div class="ly-detail-content">
                            <wrk-tab
                              :wflowStepId="process.wflowStepId"
                              :iTabGroupNum="process.iTabGroupNum"
                              :tabProcessData="viewWorkflowProcessList"
                              :processData="workflowProcessList"
                              :screenData="workflowScreenList"
                              :exeWflowId="exeWflowInfo.exeWflowId"
                              :svcCtlogId="exeWflowInfo.tgtCtlogId"
                              :depth1SvcCtlogId="exeWflowInfo.wrkType1"
                              :depth2SvcCtlogId="exeWflowInfo.wrkType2"
                              :idcCd="exeWflowInfo.idcCd"
                              :svcNo="exeWflowInfo.svcNo"
                              :custId="exeWflowInfo.custId"
                              :stepCd="step.wflowStepCd"
                              :ticketInfo="allExeWflowTicketList"
                              :allTicketList="allExeWflowTicketList"
                              :disabledBtn="false"
                            ></wrk-tab>
                          </div>
                        </div>
                      </template>
                      <!-- 탭으로 표시되지 않을 공정 -->
                      <template
                        v-else-if="
                          step.wflowStepCd == process.stepCd &&
                          process.iTabGroupNum == 0
                        "
                      >
                        <div :key="process.wflowPrcssId">
                          <!-- 공정티켓 -->
                          <!--
                          <el-divider class="top-divider"></el-divider>
                          <wrk-prcss-comm-btn
                            :key="
                              'btn_process_' +
                              process.ticktId +
                              '_' +
                              Date.now()
                            "
                            v-if="step.wflowStepCd == activeName"
                            :location="'N'"
                            :enableArea="process.buttActvaYn == 'Y'"
                            :exeWflowId="exeWflowInfo.exeWflowId"
                            :stepCd="activeName"
                            :ticktId="process.ticktId"
                            :activeButtonList="
                              process.actvButtCdList != null
                                ? process.actvButtCdList.split(',')
                                : []
                            "
                            :allTicketList="allExeWflowTicketList"
                          ></wrk-prcss-comm-btn> -->
                          <template v-for="scrn in workflowScreenList">
                            <div
                              class="tab-table"
                              :key="scrn.wflowScrnId"
                              v-if="
                                step.wflowStepId == process.wflowStepId &&
                                process.wflowPrcssId === scrn.wflowPrcssId
                              "
                            >
                              <div class="ly-detail-content">
                                <wrk-comp
                                  :isShowTitle="true"
                                  :compTitle="scrn.scrnTitle"
                                  :compNm="scrn.compNm"
                                  :defaultValue="
                                    scrn.basDataSetupYn === 'Y'
                                      ? JSON.parse(scrn.basSetupData)
                                      : {}
                                  "
                                  :exeWflowId="exeWflowInfo.exeWflowId"
                                  :svcCtlogId="exeWflowInfo.tgtCtlogId"
                                  :depth1SvcCtlogId="exeWflowInfo.wrkType1"
                                  :depth2SvcCtlogId="exeWflowInfo.wrkType2"
                                  :prcssTypeCd="process.prcssTypeCd"
                                  :idcCd="exeWflowInfo.idcCd"
                                  :svcNo="exeWflowInfo.svcNo"
                                  :custId="exeWflowInfo.custId"
                                  :stepCd="step.wflowStepCd"
                                  :mainPrcssId="process.wflowPrcssId"
                                  :subPrcssId="null"
                                  :wflowScrnId="scrn.wflowScrnId"
                                  :scrnId="scrn.scrnId"
                                  :mandDataChkYn="
                                    scrn.mandDataChkYn === 'Y' ? 'Y' : 'N'
                                  "
                                  :sftyChkMandChkYn="
                                    scrn.sftyChkMandChkYn === 'Y' ? 'Y' : 'N'
                                  "
                                  :sftyChkScrnYn="
                                    scrn.sftyChkScrnYn === 'Y' ? 'Y' : 'N'
                                  "
                                  :scrnGetApi="scrn.getApi"
                                  :scrnPostApi="scrn.postApi"
                                  :scrnPutApi="scrn.putApi"
                                  :scrnDeleteApi="scrn.deleteApi"
                                  :ticktId="process.ticktId"
                                  :groupTicktId="process.groupTicktId"
                                  :allTicketList="allExeWflowTicketList"
                                ></wrk-comp>
                              </div>
                            </div>
                          </template>
                        </div>
                      </template>
                      <template v-else></template>
                    </template>
                  </el-tab-pane>
                  <!-- ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////// -->
    </el-tabs>
    <!--
    <div class="dialog-footer align-r">
      <el-button type="info" @click="closeWorkInfoDetailModal">{{ $t("messages.btnClose") }}</el-button>
    </div> -->
  </div>
</template>

<script>
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";

import WrkPrgList from "@/components/idcUsageStatus/requestStatus/wrkComponents/wrkProgress/WrkPrgList.vue";
import WrkPrgFlowDetail from "@/components/idcUsageStatus/requestStatus/wrkComponents/wrkProgress/WrkPrgFlowDetail.vue";
// import WrkPrgListDetail from "@/components/idcUsageStatus/requestStatus/wrkComponents/wrkProgress/WrkPrgListDetail.vue";

import WrkTab from "@/components/listComponents/wrkComponents/WrkTab.vue";
import WrkComp from "@/components/listComponents/wrkComponents/WrkComp.vue";

export default {
  props: {
    exeWflowId: {
      type: String,
      default: "",
    },
  },
  components: {
    Loading,

    WrkPrgList,
    // WrkPrgListDetail,
    WrkPrgFlowDetail,

    WrkTab,
    WrkComp,
  },
  data() {
    return {
      isLoadingDetail: false, // 데이터 로딩

      userInfo: {},

      // ----------------------------------------------------
      activeName: "wrkprogress", // 현재 단계 탭

      // 진행상태
      // 작업진행정보 - 상태표
      flowWorkflowStatus: [
        {
          title: this.$t("messages.lblWait"),
          listClass: "wait",
        },
        {
          title: this.$t("messages.lblProgress"),
          listClass: "doing",
        },
        {
          title: this.$t("messages.lblPendding"),
          listClass: "pend",
        },
        {
          title: this.$t("messages.lblComplete"),
          listClass: "end",
        },
      ],

      // 워크플로우
      workflowInfo: {}, // Workflow 정보
      workflowStepList: [], // Workflow 단계 목록
      workflowProcessList: [], // Workflow 공정(작업) 목록
      workflowScreenList: [], // Workflow 화면 목록

      // 실행워크플로우
      exeWflowInfo: {}, // 실행 Workflow 정보
      exeWflowTicketList: [], // 실행 Workflow 티켓 목록
      allExeWflowTicketList: [], // 실행 Workflow 티켓 목록 (전체)

      viewWorkflowProcessList: [],

      mspSvcCtlogId: '1647947738791356',
      // 등록, 접수, 할당, 계획, 승인, 수행, 완료
      enableStepCds: [2864, 2865, 2866, 2867, 2868, 2869, 2870],
    };
  },
  computed: {
    fileterWrkStep() {
      return this.workflowStepList.filter(tmpStep => {
        if (this.enableStepCds.indexOf(tmpStep.wflowStepCd) > -1) return tmpStep;
      })
    },
    calFlowWorkflow() {
      var resultFlow = [];

      // 단계 설정
      this.workflowStepList.forEach((step) => {
        if (step.useYn != "Y") return;

        resultFlow.push({
          classDetail: "wait",
          size: "large",
          oneDepth: true,
          title: step.wflowStepKoNm, // TODO 한/영 처리
          stepCd: step.wflowStepCd,
          stepApv: step.apvStepYn == "Y" ? "Y" : "N",
          stepAuto: step.stepCmpltSetupCd == 3003 ? "N" : "Y",
          twoDepth: [],
        });
      });

      resultFlow.forEach((tmpStep) => {
        // 단계 티켓만 있는 경우 체크
        var onlyStepTicket = true;
        for (var chkTicket of this.allExeWflowTicketList) {
          if (tmpStep.stepCd == chkTicket.stepCd && chkTicket.wrkCtgCd != 0) {
            onlyStepTicket = false;
            break;
          }
        }

        var crrStepTicket = [];
        this.allExeWflowTicketList.forEach((tmpTicket) => {
          if (tmpStep.stepCd != tmpTicket.stepCd) return;

          // 단계완료가 승인단계인 경우
          if (tmpStep.stepApv == "Y") {
            crrStepTicket.push(
              Object.assign(
                {
                  flag: onlyStepTicket,
                  stepApv: tmpStep.stepApv,
                },
                tmpTicket
              )
            );
            return;
          }

          // 단계완료가 자동인 경우 티켓에 맞는 공정 표기
          if (tmpStep.stepAuto == "Y") {
            crrStepTicket.push(
              Object.assign(
                {
                  flag: onlyStepTicket,
                  stepApv: tmpStep.stepApv,
                },
                tmpTicket
              )
            );
            return;
          }

          // 단계완료가 수동이고 작업(공정)이 일반인 경우 티켓에 맞는 공정 표기
          if (tmpStep.stepAuto == "N" && tmpTicket.wrkCtgCd != 0) {
            crrStepTicket.push(
              Object.assign(
                {
                  flag: onlyStepTicket,
                  stepApv: tmpStep.stepApv,
                },
                tmpTicket
              )
            );
            return;
          }

          crrStepTicket.push(
            Object.assign(
              {
                flag: onlyStepTicket,
                stepApv: tmpStep.stepApv,
              },
              tmpTicket
            )
          );
        });

        for (var tmpTicket of crrStepTicket) {
          for (var tmpProcess of this.workflowProcessList) {
            if (tmpTicket.stepCd != tmpProcess.wflowStepCd) continue;

            var classType = "default-doing";
            var wrkCtgNm = "";
            if (!(tmpTicket.wrkCtgCd == 0 || tmpTicket.wrkCtgCd == 2883)) {
              // wrkCtgCdEngNm: "케이지"
              // wrkCtgCdHnglNm: "케이지"
              wrkCtgNm = " (" + tmpTicket.wrkCtgCdHnglNm + ")";
            }
            switch (tmpTicket.ticktSttusCd) {
              case 2876: // 완료
              case 2874: // 반려
                classType = "default-end";
                break;
              case 2875: // 보류
                classType = "pend";
                break;
              case 2871: // 대기
              case 2872: // 승인요청
                classType = "default";
                break;
              default:
                classType = "default-doing";
                break;
            }

            if (tmpTicket.stepApv == "Y" && tmpTicket.wflowPrcssId == null) {
              tmpStep.twoDepth.push({
                classDetail: classType,
                title: tmpProcess.wflowPrcssHnglNm + wrkCtgNm,
                status: tmpTicket.ticktSttusCd,
                stepCd: tmpTicket.stepCd,
                prcssId: tmpProcess.wflowPrcssId,
              });
            }
            if (tmpTicket.wflowPrcssId == tmpProcess.wflowPrcssId) {
              tmpStep.twoDepth.push({
                classDetail: classType,
                title: tmpProcess.wflowPrcssHnglNm + wrkCtgNm,
                status: tmpTicket.ticktSttusCd,
                stepCd: tmpTicket.stepCd,
                prcssId: tmpProcess.wflowPrcssId,
              });
              break;
            }

            if (
              tmpTicket.wflowPrcssId == null &&
              tmpTicket.wrkCtgCd == tmpProcess.prcssTypeCd
            ) {
              tmpStep.twoDepth.push({
                classDetail: classType,
                title: tmpProcess.wflowPrcssHnglNm + wrkCtgNm,
                status: tmpTicket.ticktSttusCd,
                stepCd: tmpTicket.stepCd,
                prcssId: tmpProcess.wflowPrcssId,
              });
              break;
            }
          }
        }
      });

      // 단계 상태 설정
      resultFlow.forEach((step) => {
        if (step.twoDepth.length == 0) {
          step.classDetail = "default";
        } else {
          var iNoneCompleteCount = 0;
          step.twoDepth.forEach((process) => {
            if (process.status != 2876) iNoneCompleteCount++;
          });
          if (iNoneCompleteCount == 0) {
            step.classDetail = "default-end";
          } else {
            step.classDetail = "default-doing";
          }
        }
      });

      return resultFlow;
    },
  },
  mounted() {
    this.$nextTick(async () => {
      const userInfo = await this.$store.getters[
        "userInfoStore/getLoginUserInfo"
      ];
      this.userInfo = userInfo;
      this.getExeWorkflow();
    });
  },
  methods: {
    gotoWrkPrcssTab() {
      this.activeName = "wrkprogress";
      this.isLoadingDetail = false;
    },

    // 실행 워크플로우 조회
    getExeWorkflow() {
      if (this.exeWflowId == null || this.exeWflowId == "") return;

      this.isLoadingDetail = true;

      this.$BIZ_SERVICE
        .post(this.$API_URLS.Svc.getPrcssWflow, {
          exeWflowId: this.exeWflowId,
        })
        .then(async (res) => {
          this.exeWflowInfo = res.data.resData;

          // 상위서비스카탈로그에 따라 보인 진행상태가 다름
          // 단계 변경 (22.08.19)
          // MSP - 전단계
          // 이외 - 등록 / 수행 / 완료
          if (this.exeWflowInfo.topCtlogId != this.mspSvcCtlogId) {
            this.enableStepCds = [2864, 2869, 2870]
          }

          await this.getWorkflow(this.exeWflowInfo.wflowId);

          return res;
        })
        /*
        .then(async (res) => {
          // 처음에는 조회 할 필요가 없을 듯.
          // this.getExeWorkflowDetail(this.exeWflowId)
        })
        */
        .catch((err) => {
          // alert 후 화면 닫기
          console.log("조회 오류");
          console.log(err);
        })
        .finally(async () => {
          await this.tabClickByExeWflowDetail(this.exeWflowInfo.exeWflowId);
          this.isLoadingDetail = false;
        });
    },

    // 워크플로우 정보 조회
    async getWorkflow(wflowId) {
      const isLogEnableByWflow = false; // 로그용 플래그

      try {
        // 1. 워크플로우 조회
        const resWflow = await this.$BIZ_SERVICE.post(
          this.$API_URLS.Svc.getWflow,
          {
            wflowId: wflowId,
          }
        );
        const isStatusByWflow = resWflow.status == 200;
        const isEmptyByWflow = Object.keys(resWflow.data.resData).length > 0;
        if (isStatusByWflow && isEmptyByWflow) {
          if (isLogEnableByWflow) {
            console.log("--------------------------------------------------");
            console.log("워크플로우 조회 - workflowInfo");
            console.table(resWflow.data.resData);
          }
          this.workflowInfo = resWflow.data.resData;
        }

        // 2. 워크플로우 단계 조회
        const resWflowStepList = await this.$BIZ_SERVICE.post(
          this.$API_URLS.Svc.getWflowStepList,
          {
            wflowId: this.workflowInfo.wflowId,
            useYn: "Y",
          }
        );
        const isStatusByWflowStepList = resWflowStepList.status == 200;
        const isDataLengthByWflowStepList =
          resWflowStepList.data.resData.length > 0;
        if (isStatusByWflowStepList && isDataLengthByWflowStepList) {
          if (isLogEnableByWflow) {
            console.log("--------------------------------------------------");
            console.log("워크플로우 단계 조회 - workflowStepList");
            console.table(resWflowStepList.data.resData);
          }
          this.workflowStepList = resWflowStepList.data.resData;
          this.$store.commit(
            "wflowStore/setWflowStepList",
            resWflowStepList.data.resData
          );
        }

        // 3. 워크플로우 공정 조회
        const resWflowPrcssList = await this.$BIZ_SERVICE.post(
          this.$API_URLS.Svc.getWflowPrcssList,
          {
            wflowId: this.workflowInfo.wflowId,
            useYn: "Y",
            delYn: "N",
          }
        );
        const isStatusByWflowPrcssList = resWflowPrcssList.status == 200;
        const isDataLengthByWflowPrcssList =
          resWflowPrcssList.data.resData.length > 0;
        if (isStatusByWflowPrcssList && isDataLengthByWflowPrcssList) {
          if (isLogEnableByWflow) {
            console.log("--------------------------------------------------");
            console.log("워크플로우 공정 조회 - workflowProcessList");
            console.table(resWflowPrcssList.data.resData);
          }

          var resultList = resWflowPrcssList.data.resData;
          // 워크플로우 공정에 단계 코드 등록
          resultList.forEach((process) => {
            this.workflowStepList.forEach((step) => {
              if (step.wflowStepId == process.wflowStepId) {
                process.wflowStepCd = step.wflowStepCd;
              }
            });
          });
          this.workflowProcessList = resultList;
          this.$store.commit("wflowStore/setWflowProcessList", resultList);
        }

        // 4. 워크플로우 화면 조회
        const resWflowScrnList = await this.$BIZ_SERVICE.post(
          this.$API_URLS.Svc.getWflowScrnList,
          {
            wflowId: this.workflowInfo.wflowId,
            delYn: "N",
          }
        );
        const isStatusByWflowScrnList = resWflowScrnList.status == 200;
        const isDataLengthByWflowScrnList =
          resWflowScrnList.data.resData.length > 0;
        if (isStatusByWflowScrnList && isDataLengthByWflowScrnList) {
          if (isLogEnableByWflow) {
            console.log("--------------------------------------------------");
            console.log("워크플로우 화면 조회 - workflowScreenList");
            console.table(resWflowScrnList.data.resData);
          }
          this.workflowScreenList = resWflowScrnList.data.resData;
          this.$store.commit(
            "wflowStore/setWflowScreenList",
            resWflowScrnList.data.resData
          );
        }
      } catch (err) {
        throw err;
      }
    },

    async getExeWorkflowDetail(exeWflowId) {
      const isLogEnableByExeWflow = false; // 로그용 플래그

      // 1. 실행워크플로우 티켓 조회
      var searchData = {
        exeWflowId: exeWflowId,
        loginUserId: this.userInfo.userId,
      };
      const resultList = await this.$store.dispatch(
        "wflowStore/getExeWflowTicketList",
        searchData
      );
      if (resultList.length > 0) {
        // 전체 티켓 목록 설정
        this.allExeWflowTicketList = resultList;

        // 티켓 정렬
        const descExeWflowTicketList = resultList.sort(function (a, b) {
          if (a.ticktAsgnDt < b.ticktAsgnDt) return 1;
          if (a.ticktAsgnDt > b.ticktAsgnDt) return -1;
          if (a.ticktAsgnDt === b.ticktAsgnDt) return 0;
          else return 1;
        });

        if (isLogEnableByExeWflow) {
          // 티켓 정렬 확인 로그
          console.table(descExeWflowTicketList, [
            "ticktId",
            "upTicktId",
            "groupTicktId",
            "stepCd",
            "stepCdHnglNm",
            "ticktSttusCd",
            "ticktSttusCdEngNm",
            "wrkCtgCd",
            "wrkCtgCdHnglNm",
            "asgnWrkGroupId",
            "asgnWrkGroupNm",
            "asgnrId",
            "asgnrNm",
          ]);
        }

        // 1차 필터
        const filterExeWflowTicketList = descExeWflowTicketList.filter(
          (ticket, index, arr) => {
            // TODO 공정인 경우 중복 제거를 시도...
            // 반려로 다시 온 공정은 어떻게... 데이터는 어떻게...
            // if (ticket.wrkCtgCd != 0 && ticket.wrkCtgCd != 2883) return ticket;
            return (
              arr.findIndex(
                (tmp) => tmp.groupTicktId === ticket.groupTicktId
              ) === index
            );
          }
        );
        if (isLogEnableByExeWflow) {
          // 티켓 1차 필터 확인 로그
          console.table(filterExeWflowTicketList, [
            "ticktId",
            "upTicktId",
            "groupTicktId",
            "stepCd",
            "stepCdHnglNm",
            "ticktSttusCd",
            "ticktSttusCdEngNm",
            "wrkCtgCd",
            "wrkCtgCdHnglNm",
            "asgnWrkGroupId",
            "asgnWrkGroupNm",
            "asgnrId",
            "asgnrNm",
          ]);
        }

        filterExeWflowTicketList.forEach((ticket) => {
          // 한번이라도 진행이 된 단계를 체크
          this.workflowStepList.forEach((step) => {
            if (step.wflowStepCd == ticket.stepCd) {
              step.active = "Y";
            }
          });
        });

        if (isLogEnableByExeWflow) {
          console.log("필터된 티켓 정보 확인");
          console.table(filterExeWflowTicketList);
        }
        this.exeWflowTicketList = filterExeWflowTicketList;
      }

      // 2. 실행워크플로우 공정처리데이터 연결 조회
      if (this.activeName != "wrkprogress") {
        await this.$store.dispatch("wflowStore/geteWflowPrcssTrtDataCnctList", {
            exeWflowId: exeWflowId,
            stepCd: Number(this.activeName),
          });
        /*
        const resExeWflowPrcssTrtDataCnctList = await this.$BIZ_SERVICE.post(
          this.$API_URLS.Svc.getPrcssTrtDataCnctList,
          {
            exeWflowId: exeWflowId,
            stepCd: Number(this.activeName),
          }
        );
        if (isLogEnableByExeWflow) {
          console.log(
            "실행워크플로우 공정연결데이터 조회 - exeWflowPrcssTrtDataCnctList"
          );
          console.table(resExeWflowPrcssTrtDataCnctList.data.resData);
        }
        this.$store.commit(
          "wflowStore/setExeWflowPrcssTrtDataCnctList",
          resExeWflowPrcssTrtDataCnctList.data.resData
        );
        */
      }
    },

    async tabClickByExeWflowDetail() {
      this.isLoadingDetail = true;

      // 1. 실행워크플로우 조회 (티켓, 공정처리아이디)
      await this.getExeWorkflowDetail(this.exeWflowInfo.exeWflowId);

      if (this.activeName == "wrkprogress") {
        this.$store.commit("wflowStore/setWflowCurrentStepCd", 0);

        this.isLoadingDetail = false;
        return;
      }

      // 티켓 초기화
      this.$store.commit("wflowStore/setExeWflowTicketList", []);

      // 컴포넌트 Validate Check Store 초기화
      this.$store.commit("wflowStore/setWrkComponentStore", []);

      // 화면에 보일 공정(상위공정) 초기화
      this.viewWorkflowProcessList = [];

      // 3. 단계에 따른 상태 체크
      for (var step of this.workflowStepList) {
        // 진행하지 않은 단계 선택 시 처리
        if (
          step.active !== "Y" &&
          Number(this.activeName) == step.wflowStepCd
        ) {
          alert("진행하지 않은 단계입니다.");
          setTimeout(() => {
            this.gotoWrkPrcssTab();
          }, 500);
          return;
        }
      }

      // 4. 화면에 배치할 공정 분류 작업
      // 선택한 단계에 해당한 티켓만 분류
      var crrTicketList = [];
      for (var tmpTicket of this.exeWflowTicketList) {
        if (tmpTicket.stepCd == Number(this.activeName)) {
          crrTicketList.push(Object.assign({}, tmpTicket));
        }
      }

      // 분류작업
      // - 선택한 단계의 상위공정만 분류
      var depth1ProcessList = [];
      for (var wProcess of this.workflowProcessList) {
        var isChkHasChild = false;
        for (var tmp of this.workflowProcessList) {
          if (tmp.upWflowPrcssId == wProcess.wflowPrcssId) {
            isChkHasChild = true;
            break;
          }
        }

        const isChkEqualStepCd =
          wProcess.wflowStepCd == Number(this.activeName);
        const isChkEmptyUpWflowPrcssId = wProcess.upWflowPrcssId == null;
        if (isChkEqualStepCd && isChkEmptyUpWflowPrcssId) {
          var tmp = Object.assign(
            {
              isCreateTab: false,
              isChild: isChkHasChild,
            },
            wProcess
          );
          depth1ProcessList.push(tmp);
        }
      }

      var crrViewProcessList = [];
      for (var ticket of crrTicketList) {
        // 단계 티켓에 대한 작업(상위공정) 추가
        if (ticket.wrkCtgCd == 0) {
          depth1ProcessList.forEach((process) => {
            if (process.prcssTypeCd == 0) {
              crrViewProcessList.push(Object.assign({}, ticket, process));
            }
          });
        }
        // 공정 티켓에 대한 작업(상위공정) 추가
        else {
          depth1ProcessList.forEach((process) => {
            if (
              process.prcssTypeCd == ticket.wrkCtgCd &&
              process.wflowPrcssId == ticket.wflowPrcssId
            ) {
              crrViewProcessList.push(Object.assign({}, ticket, process));
            }
          });
        }
      }

      // 승인(승인 / 완료) 여부에 따른 티켓 기준이 아닌 공정 추가
      var crrApvStepYn = "N";
      const stepList = this.$store.getters["wflowStore/getWflowStepList"];
      for (var tmpStep of stepList) {
        if (tmpStep.wflowStepCd == Number(this.activeName)) {
          crrApvStepYn = tmpStep.apvStepYn != "Y" ? "N" : tmpStep.apvStepYn;
        }
      }
      if (crrApvStepYn == "Y") {
        // console.log("승인 공정 추가");
        // console.log(crrTicketList);
        depth1ProcessList.forEach((process) => {
          crrViewProcessList.push(
            Object.assign(
              {
                stepCd: process.wflowStepCd,
              },
              process
            )
          );
        });
      }

      // 공정 정렬
      crrViewProcessList = crrViewProcessList.sort(function (a, b) {
        const aValue = a.prcssOdrg == null ? 0 : Number(a.prcssOdrg);
        const bValue = b.prcssOdrg == null ? 0 : Number(b.prcssOdrg);
        return aValue - bValue;
      });

      // 탭분류
      // - 상위 공정이 선택안함또는 일반이 아닌 경우
      var iTabGroupNum = 0;
      var isCreateTab = false;
      crrViewProcessList.forEach((process, index) => {
        isCreateTab = false;
        if (process.isChild) {
          if (index == 0) {
            isCreateTab = true;
            iTabGroupNum++;
          } else {
            if (!crrViewProcessList[index - 1].isChild) {
              isCreateTab = true;
              iTabGroupNum++;
            }
          }
        }
        process.isCreateTab = isCreateTab;
        process.iTabGroupNum = iTabGroupNum;
      });

      //console.log("3. 분류공정목록 - 탭처리");
      //console.log(crrViewProcessList);
      /*
      console.table(crrViewProcessList, [
        "ticktId",
        "wflowStepId",
        "ticktSttusCdEngNm",
        "wflowPrcssHnglNm",
        "isCreateTab",
        "isChild",
        "iTabGroupNum",
        ]);
        */

      this.viewWorkflowProcessList = crrViewProcessList;

      this.$store.commit(
        "wflowStore/setWflowCurrentStepCd",
        Number(this.activeName)
      );

      console.log("단계 탭 처리완료");
      //console.log(this.viewWorkflowProcessList);
      console.table(this.viewWorkflowProcessList);

      this.isLoadingDetail = false;
    },
    closeWorkInfoDetailModal() {
      this.$emit("closeWorkInfo");
    },
  },
};
</script>

<style lang="scss" scoped>
.el-divider {
  margin: 20px 0 0 0;
}
::v-deep {
  .input-btn {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 5px;
    margin-top: 5px;
    &-table {
      margin-top: 0;
    }
  }
}
</style>
